import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import asyncComponent from '../../hoc/asyncComponent/asyncComponent';
import withAWSAuth from '../../hoc/withAWSAuth/withAWSAuth';
import Layout from '../../components/Layout/Layout';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCogs, faTachometerAlt, faCameraRetro, faKeyboard, faNotEqual, faUserCircle, faChartBar, faExclamation, faFileUpload, faDownload} from '@fortawesome/free-solid-svg-icons';
library.add(faCogs, faTachometerAlt, faCameraRetro, faKeyboard, faNotEqual, faUserCircle, faChartBar, faExclamation, faFileUpload, faDownload);

const asyncOverview = asyncComponent(() => {
  return import('../Overview/Overview');
});

const asyncKeywordExportToolContainer = asyncComponent(() => {
  return import('../KeywordExportTool/KeywordExportTool');
});

const asyncTitleDescriptionToolContainer = asyncComponent(() => {
  return import('../TitleDescriptionTool/TitleDescriptionTool');
});

const asyncBulkUploadTool = asyncComponent(() => {
  return import('../BulkUploadTool/BulkUploadTool')
})

const asyncPageNotFound = asyncComponent(() => {
  return import ('../ErrorPages/PageNotFound/PageNotFound');
})

const asyncForbidden = asyncComponent(() => {
  return import ('../ErrorPages/Forbidden/Forbidden');
})

const asyncUnauthorizedUser = asyncComponent(() => {
  return import ('../ErrorPages/UnauthorizedErrorPage/UnauthorizedErrorPage');
})

const asyncContentGenerationTool = asyncComponent(() => {
  return import ('../ContentGenerationTool/ContentGenerationTool');
})

const asyncContentGenerationDetail = asyncComponent(() => {
  return import('../ContentGenerationTool/ContentGenerationDetail');
});

class App extends Component {
  render() {
    return (
      <div>
        <Layout>
          <Switch>
            <Route path="/" exact component={asyncOverview} />
            <Route path="/keyword-export-tool" exact component={asyncKeywordExportToolContainer} />
            <Route path="/title-description-tool" exact component={asyncTitleDescriptionToolContainer}/>
            <Route path="/bulk-upload-tool" exact component={asyncBulkUploadTool}/>
            <Route path="/content-generation-tool" exact component={asyncContentGenerationTool}/>
            <Route path="/content-generation-tool/detail/:work_done_id" exact component={asyncContentGenerationDetail}/>
            <Route path="/unauthorized" component={asyncUnauthorizedUser} />
            <Route path="/forbidden" component={asyncForbidden} />
            <Route path="*" component={asyncPageNotFound} />
          </Switch>
        </Layout>
      </div>
    );
  };
}

export default withAWSAuth(withRouter(connect()(App)));
